import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AutosizeModule } from 'ngx-autosize';

@Component({
  selector: 'app-chat-input',
  imports: [CommonModule, FormsModule, AutosizeModule],
  templateUrl: './chat-input.component.html'
})
export class ChatInputComponent {
  @Input() isLoading = false;
  @Output() sendMessage = new EventEmitter<string>();

  input = '';

  handleKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      this.handleSendMessage();
    }
  }

  handleSendMessage(): void {
    if (!this.input.trim() || this.isLoading) return;

    this.sendMessage.emit(this.input);
    this.input = '';
  }
}
